module.exports = __webpack_public_path__ + "static/media/Icon ionic-ios-hand.67c29d19.svg";